export const isAdmin = (user) =>
  user && user.email === 'peter.tornhult@gmail.com'
